import * as React from 'react'

export type TAvatarRootContext = {
  name?: string
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'
}

export const AvatarRootContext = React.createContext<TAvatarRootContext>({
  name: undefined,
  size: 'lg'
})
